import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {saveAs} from 'file-saver';
import {autobind} from 'core-decorators';
import {bufferToBlob, getDisplayName} from '@ciscospark/react-component-utils';
import {retrieveSharedFile} from '@ciscospark/redux-module-share';

import getContainerProps from './selectors';

// eslint-disable-next-line no-warning-comments
// TODO: Rename this project to react-hoc-file-downloader

function injectFileDownloader(WrappedComponent) {
  const injectedPropTypes = {
    share: PropTypes.object.isRequired,
    spark: PropTypes.object.isRequired,
    retrieveSharedFile: PropTypes.func.isRequired
  };

  const propTypes = {
    files: PropTypes.array,
    ...injectedPropTypes
  };

  const defaultProps = {
    files: []
  };

  class FileDownloader extends Component {
    componentDidMount() {
      const {files} = this.props;

      files.forEach((file) => {
        this.getThumbnailImage(file);
      });
    }

    @autobind
    getSharedFileFromStore(fileUrl) {
      const {props} = this;

      return props.share.get(['files', fileUrl]);
    }

    getThumbnailImage(fileObject) {
      const {image} = fileObject;

      if (fileObject.mimeType === 'image/gif' && fileObject.url) {
        this.retrieveFile(fileObject);
      }
      else if (image && (image.url && !this.getSharedFileFromStore(image.url) || image.scr)) {
        this.retrieveFile(image);
      }
    }

    @autobind
    retrieveFile(file) {
      const {props} = this;

      props.retrieveSharedFile(file, props.spark);
    }

    @autobind
    handleDownloadClick(fileObject) {
      const {props} = this;
      const cachedFile = this.getSharedFileFromStore(fileObject.url);

      if (cachedFile && cachedFile.blob) {
        saveAs(cachedFile.blob, fileObject.displayName);
      }
      else {
        props.retrieveSharedFile(fileObject, props.spark)
          .then((file) => {
            const {blob} = bufferToBlob(file);

            saveAs(blob, file.name);
          });
      }
    }

    render() {
      return <WrappedComponent onDownloadClick={this.handleDownloadClick} {...this.props} />;
    }
  }


  FileDownloader.propTypes = propTypes;
  FileDownloader.defaultProps = defaultProps;

  FileDownloader.displayName = `FileDownloader(${getDisplayName(WrappedComponent)})`;
  FileDownloader.WrappedComponent = WrappedComponent;

  return connect(
    getContainerProps,
    (dispatch) => bindActionCreators({
      retrieveSharedFile
    }, dispatch)
  )(FileDownloader);
}

export default injectFileDownloader;
